import { styled } from "@mui/material/styles";

import { COLOR_PRIMARY_BLACK, COLOR_PRIMARY_WHITE } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { STORE_DEPARTMENT_WITH_IMAGE_CLASSES } from "./constants";

interface StylesProps {
  textColor?: string;
  departmentURL?: boolean;
  isStoreSelector?: boolean;
}

export const StoreDepartmentWithImageContainer = styled("div")<StylesProps>(({
  theme,
  textColor,
  departmentURL,
  isStoreSelector,
}) => {
  const formatMedia = getFormatMedia(theme);
  return {
    [`& .${STORE_DEPARTMENT_WITH_IMAGE_CLASSES.root}`]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      textDecoration: "none",
      padding: theme.spacing(2),
      height: 114,
      color: textColor === "light" ? COLOR_PRIMARY_WHITE : COLOR_PRIMARY_BLACK,
      cursor: !departmentURL && "auto",
      [formatMedia.BREAKPOINT_TABLET]: {
        height: isStoreSelector ? 100 : 104,
      },
    },
    [`& .${STORE_DEPARTMENT_WITH_IMAGE_CLASSES.text}`]: {
      zIndex: 1,
    },
    [`& .${STORE_DEPARTMENT_WITH_IMAGE_CLASSES.name}`]: {
      ...theme.typography.h5,
    },
    [`& .${STORE_DEPARTMENT_WITH_IMAGE_CLASSES.floor}`]: {
      ...theme.typography.body1,
    },
    [`& .${STORE_DEPARTMENT_WITH_IMAGE_CLASSES.image}`]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 0,
      width: "100%",
      objectFit: "cover",
      height: "100%",
    },
  };
});
